import { match as locale } from "../../../src/params/locale.js";

export const matchers = { locale };